import React, { useEffect, useState } from 'react';

import { Reason } from '../../../common/constants/reasons';
import ElementLocators from '../../../common/ElementLocators';
import { ReasonChoice } from './ReasonChoice';
import styles from './styles.module.scss';

export const ReasonsChoicePanel = ({
  reasons,
  selectedReasons,
  selectReasonsCallback,
  formChangeHandler,
}: {
  reasons: Reason[];
  selectedReasons: string[];
  selectReasonsCallback: React.Dispatch<React.SetStateAction<string[]>>;
  formChangeHandler?: (value: string[]) => void;
}) => {
  const [selectedReasonsList, setSelectedReasonsList] =
    useState(selectedReasons);

  useEffect(() => {
    if (formChangeHandler) {
      formChangeHandler(selectedReasons);
    }
    setSelectedReasonsList(selectedReasons);
  }, [selectedReasons]);

  const reasonSelection = (reason: Reason) => {
    const currentSelection = selectedReasonsList.includes(reason.key)
      ? selectedReasonsList.filter(key => key !== reason.key)
      : [...selectedReasonsList, reason.key];
    setSelectedReasonsList(currentSelection);
    selectReasonsCallback(currentSelection);
  };

  return (
    <div
      className={styles.ReasonsPanel}
      id={ElementLocators.LOCATOR_REASON_CHOICE_PANEL}
    >
      {reasons.length &&
        reasons.map(reason => (
          <ReasonChoice
            key={reason.key}
            reason={reason}
            active={selectedReasons.indexOf(reason.key) !== -1}
            selectionCallback={reasonSelection}
          />
        ))}
    </div>
  );
};
